// src/chartConfig.ts
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  RadialLinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

// Register whatever you actually use in your app
ChartJS.register(
  CategoryScale,      // "category" scale (x-axis on bar/line charts)
  LinearScale,        // "linear" scale (y-axis)
  RadialLinearScale,  // "radialLinear" (radar/polar area)
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
);

export default ChartJS;